export const RECEIVE_WELCOME_CENTER_DOC = 'RECEIVE_WELCOME_CENTER_DOC';
export const RECEIVE_WELCOME_CENTER_DOC_FAILURE = 'RECEIVE_WELCOME_CENTER_DOC_FAILURE';
export const SET_ARRAY_MODEL = 'SET_ARRAY_MODEL';

export const GET_TECH_DOC_BEGIN = 'GET_TECH_DOC_BEGIN';
export const GET_TECH_DOC_SUCCESS = 'GET_TECH_DOC_SUCCESS';
export const GET_TECH_DOC_FAILURE = 'GET_TECH_DOC_FAILURE';
export const TECH_DOC_PAGE_UNLOADED = 'TECH_DOC_PAGE_UNLOADED';
export const RESET_TECH_DOC = 'RESET_TECH_DOC';

export const GET_MODEL_LIST_SUCCESS = 'GET_MODEL_LIST_SUCCESS';

export const GET_CHECKLIST_SUCCESS = 'GET_CHECKLIST_SUCCESS';
export const GET_CHECKLIST_BEGIN = 'GET_CHECKLIST_BEGIN';
export const GET_CHECKLIST_FAILURE = 'GET_CHECKLIST_FAILURE';
export const SET_CHECKLIST_DONE = 'SET_CHECKLIST_DONE';

export const GET_RACK_STEPS_SUCCESS = 'GET_RACK_STEPS_SUCCESS';
export const GET_RACK_STEPS_BEGIN = 'GET_RACK_STEPS_BEGIN';
export const GET_RACK_STEPS_FAILURE = 'GET_RACK_STEPS_FAILURE';

export const GET_UNBOX_DOC_BEGIN = 'GET_UNBOX_DOC_BEGIN';
export const GET_UNBOX_DOC_SUCCESS = 'GET_UNBOX_DOC_SUCCESS';
export const GET_UNBOX_DOC_FAILURE = 'GET_UNBOX_DOC_FAILURE';

export const GET_CABLE_DOC_BEGIN = 'GET_CABLE_DOC_BEGIN';
export const GET_CABLE_DOC_SUCCESS = 'GET_CABLE_DOC_SUCCESS';
export const GET_CABLE_DOC_FAILURE = 'GET_CABLE_DOC_FAILURE';

export const GET_POWER_ON_DOC_BEGIN = 'GET_POWER_ON_DOC_BEGIN';
export const GET_POWER_ON_DOC_SUCCESS = 'GET_POWER_ON_DOC_SUCCESS';
export const GET_POWER_ON_DOC_FAILURE = 'GET_POWER_ON_DOC_FAILURE';

export const GET_PREREQUISITES_DOC_BEGIN = 'GET_PREREQUISITES_DOC_BEGIN';
export const GET_PREREQUISITES_DOC_SUCCESS = 'GET_PREREQUISITES_DOC_SUCCESS';
export const GET_PREREQUISITES_DOC_FAILURE = 'GET_PREREQUISITES_DOC_FAILURE';

export const GET_SETUP_DOC_BEGIN = 'GET_SETUP_DOC_BEGIN';
export const GET_SETUP_DOC_SUCCESS = 'GET_SETUP_DOC_SUCCESS';
export const GET_SETUP_DOC_FAILURE = 'GET_SETUP_DOC_FAILURE';

export const GET_VALIDATION_DOC_BEGIN = 'GET_VALIDATION_DOC_BEGIN';
export const GET_VALIDATION_DOC_SUCCESS = 'GET_VALIDATION_DOC_SUCCESS';
export const GET_VALIDATION_DOC_FAILURE = 'GET_VALIDATION_DOC_FAILURE';
export const SET_VALIDATION_DOC_DONE = 'SET_VALIDATION_DOC_DONE';

export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU';
export const GET_SIDEMENU_STATUS = 'GET_SIDEMENU_STATUS';
